document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded',function(){
  var trigger=document.querySelector('[data-mobile-menu-toggle]');
  var menu=document.querySelector('[data-mobile-menu]');
  if(trigger&&menu){trigger.addEventListener('click',function(){menu.classList.toggle('is-open');trigger.setAttribute('aria-expanded',menu.classList.contains('is-open')?'true':'false');});}

  /* Smooth anchor navigation with sticky-header compensation */
  document.addEventListener('click',function(e){
    var a=e.target.closest('a[href^="#"]');
    if(!a) return;
    var href=a.getAttribute('href');
    if(!href || href==='#') return;
    var target=document.querySelector(href);
    if(!target) return;
    e.preventDefault();
    target.scrollIntoView({behavior:'smooth',block:'start'});
    try{history.replaceState(null,'',href);}catch(err){}
  });

  /* Lightweight reveal system */
  var revealTargets=document.querySelectorAll('.section,.dalally-hero-card,.showcase-card,.category-mini-card,.enhanced-product-card,.service-panel,.newsletter-card,.dl-pdp-grid,.dl-story-intro,.dl-story-benefits,.dl-story-use,.dl-story-gallery,.dl-story-final-card,.dl-reviews,.pdp-proof-section,.pdp-faq-section,.dl-editorial,.dl-cinema-card,.dl-feature-split-grid,.dl-premium-showcase-grid,.dl-lifestyle-head,.dl-lifestyle-grid');
  revealTargets.forEach(function(el,i){el.classList.add('dl-reveal');el.dataset.delay=String(i%4);});
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('dl-inview');io.unobserve(entry.target);}});},{threshold:.08,rootMargin:'0px 0px -35px 0px'});
    revealTargets.forEach(function(el){io.observe(el);});
  }else{revealTargets.forEach(function(el){el.classList.add('dl-inview');});}

  /* Button ripple */
  document.addEventListener('pointerdown',function(e){
    var btn=e.target.closest('.btn'); if(!btn) return;
    var r=btn.getBoundingClientRect();
    btn.style.setProperty('--rx',(e.clientX-r.left)+'px');
    btn.style.setProperty('--ry',(e.clientY-r.top)+'px');
    btn.classList.remove('is-ripple'); void btn.offsetWidth; btn.classList.add('is-ripple');
    setTimeout(function(){btn.classList.remove('is-ripple');},600);
  });

  /* Subtle hero depth on pointer devices */
  var hero=document.querySelector('.dalally-hero-card');
  if(hero && window.matchMedia('(pointer:fine)').matches && !window.matchMedia('(prefers-reduced-motion:reduce)').matches){
    hero.addEventListener('pointermove',function(e){
      var r=hero.getBoundingClientRect(), x=(e.clientX-r.left)/r.width-.5, y=(e.clientY-r.top)/r.height-.5;
      hero.style.transform='perspective(1200px) rotateX('+(-y*1.4)+'deg) rotateY('+(x*1.8)+'deg)';
    });
    hero.addEventListener('pointerleave',function(){hero.style.transform='';});
  }
});
